import * as yup from 'yup'

const ContactSupportValidator  = yup.object({
    firstname: yup.string().required('First name is required'),
    lastname: yup.string().required('Last name is required'),
    email: yup.string().email().required('Email is required'),
    phone_number: yup.string().required('Phone number is required'),
    message: yup.string().required('Message is required')

})

export { ContactSupportValidator }